import { Close } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { getStoreByIdApi } from "../../../services/store.service";
import { useGetApi } from "../../../hooks/useGetApi";

const StoreStockViewModal = ({ open, onClose, selectedRow }) => {
  const {
    dataList: detail,
    isLoading: detailLoading,
    isError: detailError,
  } = useGetApi(
    selectedRow?._id
      ? {
          apiFunction: getStoreByIdApi,
          params: { id: selectedRow?._id },
          dependencies: [open],
        }
      : { apiFunction: null } // it is done to prevent the api call when I open it for pharmacy store creation
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "white",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        {/* dialog title */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: "20px",
          }}
        >
          <Typography variant="h6" sx={{ color: "#5D6A82" }}>
            Stock View Details
          </Typography>
          <IconButton>
            <Close
              onClick={onClose}
              sx={{ cursor: "pointer", color: "#5D6A82" }}
            />
          </IconButton>
        </Box>

        <Grid container spacing={2}>
          {/* first row */}
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                Item Code:
              </Typography>
              <Typography>{detail?.item?.itemCode || ""}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                MRP:
              </Typography>
              <Typography>{detail?.mrp || ""}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                Available Qty:
              </Typography>
              <Typography>{detail?.quantity || ""}</Typography>
            </Box>
          </Grid>

          {/* second row */}
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                Batch Code:
              </Typography>
              <Typography>{detail?.batchNo || ""}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                Purchase Rate:
              </Typography>
              <Typography>{detail?.purchaseRate || ""}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                Item Name:
              </Typography>
              <Typography>{detail?.item?.itemName || ""}</Typography>
            </Box>
          </Grid>

          {/* third row */}
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                Hospital Rate:
              </Typography>
              <Typography>{detail?.hospitalRate || ""}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                Item Type:
              </Typography>
              <Typography>
                {detail?.item?.itemType ||
                  selectedRow?.itemDetails?.itemType ||
                  ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                Supplier:
              </Typography>
              <Typography>{detail?.supplier || ""}</Typography>
            </Box>
          </Grid>

          {/* fourth row */}
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                Company:
              </Typography>
              <Typography>{detail?.company?.name || ""}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                Status:
              </Typography>
              <Typography>{detail?.status || ""}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, width: "140px" }}>
                Expiry Date:
              </Typography>
              <Typography>
                {detail?.expiryDate
                  ? dayjs(detail?.expiryDate).format("DD/MM/YYYY")
                  : "-"}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            mt: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontWeight: 600, width: "140px" }}>
              Updated By:
            </Typography>
            <Typography>{`${detail?.updatedBy?.firstName || ""} ${
              detail?.updatedBy?.lastName || ""
            }`}</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontWeight: 600, width: "140px" }}>
              Update Date:
            </Typography>
            <Typography>
              {detail?.updatedAt
                ? dayjs(detail?.updatedAt).format("DD/MM/YYYY")
                : "-"}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            mt: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontWeight: 600, width: "140px" }}>
              Invoice Number:
            </Typography>
            <Typography>{detail?.invoiceNumber || ""}</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontWeight: 600, width: "140px" }}>
              Update Time:
            </Typography>
            <Typography>
              {detail?.updatedAt
                ? dayjs(detail?.updatedAt).format("hh:mm A")
                : null}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default StoreStockViewModal;
